<template>
  <v-navigation-drawer
    app
    permanent
    :mini-variant="collapse"
    class="navigation-drawer"
    right
  >
    <!-- copyright text -->
    <template v-slot:append>
      <v-list-group append-icon="" @click="onLogout">
        <template v-slot:prependIcon>
          <LogoutIcon />
        </template>
        <template v-slot:activator>
          <v-list-item-title class="secondaryYellow--text text-caption">
            {{ $t("logout") }}
          </v-list-item-title>
        </template>
      </v-list-group>
    </template>

    <!-- application title -->
    <v-list-item class="white--text">
      <v-list-item-icon>
        <img
          src="@/assets/img/logo/favicon.png"
          alt="aironpax"
          width="34px"
          style="margin-right: -5px"
        />
      </v-list-item-icon>
      <v-list-item-title class="text-h6">
        {{ $t("aironpax") }}
      </v-list-item-title>
    </v-list-item>

    <v-list dense>
      <div v-for="item in items" :key="item.title">
        <router-link :to="item.href" active-class="activeLink">
          <v-list-group append-icon="">
            <template v-slot:prependIcon>
              <component :is="item.icon" />
            </template>
            <template v-slot:activator>
              <v-list-item-title class="white--text text-caption">
                {{ $t(item.title) }}
              </v-list-item-title>
            </template>
          </v-list-group>
        </router-link>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import PredictionIcon from "@/components/icons/Prediction.icon";
import RecommendationIcon from "@/components/icons/Recommendation.icon";
import BalanceIcon from "@/components/icons/Balance.icon";
import BalanceHistoryIcon from "@/components/icons/BalanceHistory.icon";
import HelpIcon from "@/components/icons/Help.icon";
import LogoutIcon from "@/components/icons/Logout.icon";
import { ROUTES } from "@/routes/pwa";

export default {
  name: "Navigator",

  data() {
    return {
      items: [
        {
          icon: PredictionIcon,
          title: "prediction",
          href: ROUTES.prediction,
        },
        {
          icon: RecommendationIcon,
          title: "recommendation",
          href: ROUTES.recommendation,
        },
        {
          icon: BalanceIcon,
          title: "balance",
          href: ROUTES.balance,
        },
        {
          icon: BalanceHistoryIcon,
          title: "predictionHistory",
          href: ROUTES.predictionHistory,
        },
        {
          icon: BalanceHistoryIcon,
          title: "recommendationHistory",
          href: ROUTES.recommendationHistory,
        },
        {
          icon: BalanceHistoryIcon,
          title: "balanceHistory",
          href: ROUTES.balanceHistory,
        },
        {
          icon: HelpIcon,
          title: "help",
          href: ROUTES.help,
        },
      ],
    };
  },

  props: {
    collapse: { type: Boolean, default: false },
  },

  methods: {
    onLogout() {
      this.$emit("onLogout");
    },
  },

  components: {
    LogoutIcon,
  },
};
</script>

<style lang="scss" scoped>
.activeLink {
  & > .v-list-group {
    background: rgba(255, 255, 255, 0.15);
  }
}
.version {
  direction: ltr;
  text-align: center;
}
.no-break {
  white-space: nowrap;
  overflow: hidden;
}
.navigation-drawer {
  background: linear-gradient(
    to bottom,
    var(--v-mainBlue-base),
    var(--v-text-base)
  );
}
.activeLink {
  background-color: red !important;
}
</style>
